export default "__VITE_ASSET__IdJSEk8o__"